// src/components/PostSummaryCard/PostSummaryCard.js
import './PostSummaryCard.scss';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { stripHtmlAndTruncate } from '../../helpers/textUtils';
import { useLingui } from "@lingui/react"; // <--- Import useLingui
import { Trans } from "@lingui/react/macro";



const PostSummaryCard = ({ post }) => {
    useEffect(() => {
        Aos.init({ duration: 500, once: true, easing: 'ease-in-out' });
    }, []);

    const { i18n } = useLingui(); // <--- Get the i18n object

    const formattedDate = post.date.toLocaleDateString(i18n.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone:'UTC'
    });

    const isLongPost = post.type === 'long';
    const imageUrl = post.image ? `${process.env.PUBLIC_URL}/images/blog/${post.image}` : null;

    const maxSummaryLength = 250; 
    const displayBodyText = stripHtmlAndTruncate(post.bodyHtml, maxSummaryLength);

    return (
        <div className={`news-container ${isLongPost ? 'long-post' : 'short-post'}`} data-aos="fade-left">

            {isLongPost ? (
                // --- Layout for LONG posts summary (Image on left, Text/Title on right) ---
                <>
                    {/* Date always at the top of the card */}
                    <p className='post-date'>{formattedDate}</p>

                    <div className="long-post-main-content"> {/* New wrapper for image + text block */}
                        {imageUrl && (
                            <div className='post-image'>
                                <img src={imageUrl} alt={post.title} />
                            </div>
                        )}
                        <div className="text-content-wrapper"> {/* New wrapper for Title, Subtitle, Body, Read More */}
                            <div className='title-group'>
                                <Link to = {`/novedades/${post.slug}`} style={{textDecoration: "none"}}><div className='block title'>{post.title}</div></Link>
                                {post.subtitle && <p className='subtitle'>{post.subtitle}</p>}
                            </div>
                            <div className='news-text'>
                                <p>{displayBodyText}</p>
                            </div>
                            <Link to={`/novedades/${post.slug}`} className='read-more-link'>
                                <Trans>Leer más</Trans>
                            </Link>
                        </div>
                    </div>
                </>
            ) : (
                // --- Layout for SHORT posts summary (Date, then Title, then Text) ---
                <div className="short-post-main-content">
                    {/* Date at the top left */}
                    <p className='post-date'>{formattedDate}</p>
                    
                    <div className="short-post-title-and-text"> {/* Wrapper for title and body flex */}
                        <div className='title-group'>
                            <div className='block title'>{post.title}</div>
                        </div>
                        <div className='news-text'>
                            <p>{displayBodyText}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PostSummaryCard;